module.exports = __webpack_public_path__ + "static/media/process_2.879b5bfe.png";